<template>
    <v-container fluid>

  <template>
 <v-card class="ma-3">
        <v-card-title>
          <h4 class="subheading grey--text">Φίλτρα</h4>
          <v-spacer/>
        </v-card-title>
      <v-card-text>
        <v-row>
        <v-col cols="4" sm="4">
        </v-col>
            <v-col>
            <v-badge
              class="ma-2"
              overlap
              color="secondary"
              :content="totalQtyByYear"
            >
             <v-chip outlined class="px-4 ma-0"><v-icon>mdi-cart</v-icon></v-chip>
            </v-badge>

            </v-col>
             <v-col cols="12" sm="4">
            <v-select
                v-model="invoicingPeriod"
                :items="uniqueInvoiceYears"
                :suffix="fiDate"
                label="Έτος χρήσης"
                prepend-icon="mdi-calendar"
                clearable
              ></v-select>
            </v-col>
        </v-row>
      </v-card-text>
    <v-card-actions>
    </v-card-actions>
    </v-card>
  <v-card class="d-flex-column justify-space-between ma-3 mt-4"
    :loading="loading"
    >
    <v-card-title>
       <h1 class="mr-2 subheading grey--text">Χρεώσεις</h1>
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Search"
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>
    <v-data-table
      :headers="headers"
      :items="checkouts"
      :search="search"
      loading: false
      sort-by="Date"
      sort-desc
      item-key="Id"
      class="elevation-1"
      :loading="loading"
      loading-text="Loading... Please wait"
      single-expand: true
      :expanded.sync="expanded"
    >

     <template v-slot:item.actions="{ item }">
        <v-btn
          icon
          @click.stop="showRepair(item)"
        >
         <v-icon>mdi-car-wrench</v-icon>
        </v-btn>
        <v-btn
          icon
          :to="{name: 'order-info', params: {id: item.OrderId}}"
        >
         <v-icon>mdi-dolly</v-icon>
        </v-btn>
     </template>
     <template v-slot:item.Timestamp="{ item }">
       {{  new Date(item.Timestamp).toLocaleString('default') }}
    </template>

     <template v-slot:item.Order.PartCost="{ item }">
       {{ $tocurr(item.Order.PartCost) }}
    </template>
    <template v-slot:item.RepairItem.Profit="{ item }">
    <v-tooltip top>
      <template v-slot:activator="{ on, attrs }">
        <span
          v-bind="attrs"
          v-on="on"
          >
         {{ $tocurr(item.Qty * item.RepairItem.Profit) }}
        </span>
      </template>
      <span>{{(item.RepairItem.Profit*100/item.RepairItem.Price).toFixed(2) }}%</span>
    </v-tooltip>
    </template>
    <template v-slot:item.RepairItem.Price="{ item }">
       {{ $tocurr(item.RepairItem.Price) }}
    </template>
    <template v-slot:item.SuggestedPrice="{ item }">
    <v-tooltip top>
      <template v-slot:activator="{ on, attrs }">
        <span
          v-bind="attrs"
          v-on="on"
        >      {{ $tocurr(item.SuggestedPrice) }}</span>
      </template>
      <span>{{((item.SuggestedPrice/item.PartCost-1)*100).toFixed(0)}}% - {{$tocurr(item.SuggestedPrice-item.PartCost)}}</span>
    </v-tooltip>


    </template>
   <template v-slot:body.append="{headers}">
        <tr>
            <td v-for="(header,i) in headers" :key="i">

              <div class="text-right"  v-if="header.value == 'RepairItem.Repair.Vehicle.Owner.Name'">
                  Σύνολο:
                </div>

                <div class="text-right"  v-if="header.value == 'Qty'">
                  {{ partsTotalQty }}
                </div>
                <div class="text-right"  v-if="header.value == 'RepairItem.Price'">
                  {{ tocurr(partsTotalPrice) }}
                </div>

                <div class="text-right"  v-if="header.value == 'RepairItem.Profit'">
                  {{ tocurr(partsTotalProfit) }}
                </div>

                <div v-else>
                    <!-- empty table cells for columns that don't need a sum -->
                </div>

            </td>
        </tr>
    </template>
     <template v-slot:expanded-item="{ headers, item }">
      <td :colspan="headers.length">
        Σημειώσεις: {{ item.Remarks }}<br>

        <br>

        More info about {{ item.RepairId }}<br>
        <v-simple-table
            fixed-header
            height="200px"
          >
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">
                    SKU
                  </th>
                  <th class="text-left">
                    Qty
                  </th>
                  <th class="text-left">
                    Retail Price
                  </th>
                  <th class="text-left">
                    Price
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="line in item.Invoice.LineItems"
                  :key="line.id"
                >
                  <td>{{ line.SupplierSku }}</td>
                  <td>{{ line.Qty }}</td>
                   <td>{{ tocurr(line.RetailPrice) }}</td>
                  <td>{{ tocurr(line.PartCost) }}</td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>

      </td>
    </template>



    </v-data-table>
  </v-card>
</template>


    </v-container>
</template>

<script>


export default {
  computed: {
      partsTotalPrice () {
        if (!this.invoicingPeriod) {
          return this.checkouts.reduce((a, b) => a + (b.Qty * b.RepairItem.Price|| 0), 0);
        } else {
          return this.checkouts
            .filter(checkout => checkout.Timestamp.slice(0,4) == this.invoicingPeriod)
            .reduce((a, b) => a + (b.Qty * b.RepairItem.Price|| 0), 0);
        }
      },
      partsTotalProfit() {
        if (!this.invoicingPeriod) {
          return this.checkouts.reduce((a, b) => a + (b.Qty * b.RepairItem.Profit || 0), 0);
        } else {
          return this.checkouts
            .filter(checkout => checkout.Timestamp.slice(0, 4) == this.invoicingPeriod)
            .reduce((a, b) => a + (b.Qty * b.RepairItem.Profit || 0), 0);
        }
      },
      partsTotalQty() {
        if (!this.invoicingPeriod) {
          return this.checkouts.reduce((a, b) => a + (b.Qty || 0), 0);
        } else {
          return this.checkouts
            .filter(checkout => checkout.Timestamp.slice(0, 4) == this.invoicingPeriod)
            .reduce((a, b) => a + (b.Qty || 0), 0);
        }
      },
      uniqueInvoiceYears () {
        // console.log("asdsd: ", this.uniq(this.invoices, "PlateNumber"));
        return this.uniqYears(this.checkouts);
      },
      totalQtyByYear() {
        if (this.invoicingPeriod) return this.checkouts.filter(checkout => checkout.Timestamp.slice(0,4) == this.invoicingPeriod).reduce((acc, checkout) => acc + checkout.Qty, 0)
        return this.checkouts.reduce((acc, checkout) => acc + checkout.Qty, 0)
      },
     fiDate() {
      if (!this.invoicingPeriod) return;
      return this.$tocurr(
        this.checkouts
          .filter(checkout => checkout.Timestamp.slice(0,4) == this.invoicingPeriod)
          .reduce((sum, checkout) => 
            sum + (checkout.RepairItem.Qty * checkout.RepairItem.Price), 0)
      );
    },
  },
  data() {
    return {
      expanded: [],
      diaitems: {},
      loading: true,
      balance: 0.0,
      search: '',
      usedLabelQty: 0,
      labelQty: 0,
      printDialog: false,
      invoicingPeriod: null,
      showLabelDialog: false,
      selectedItem: null, // Selected item for PrintLabelDialog
      manf: [], // Array to store selected manufacturers
      pid: this.$route.params.id,
      checkouts: [],
      part: {},
      headers: [
          {
            text: 'Αρ. Παρτίδας',
            align: 'end',
            //sortable: false,
            value: 'OrderId',
            width: '5%',
          },
          { text: 'Ημερομηνία', value: 'Timestamp', width: '10%',
            filter: (value) => {
              if (!this.invoicingPeriod) return true;
              if (this.invoicingPeriod == value.slice(0,4)) return true;
            },
          },
          { text: 'Τεχνικός', value: 'Technician.Name' },
         { text: 'Όχημα', value: 'RepairItem.Repair.Vehicle.PlateNumber', width: '8%'  },
        { text: 'Πελάτης', value: 'RepairItem.Repair.Vehicle.Owner.Name', width: '25%'  },
        //{ text: 'Επισκευή', value: 'RepairItem.RepairId',width: '10%' },
         // { text: 'Aξία', value: 'Order.PartCost', align: 'end' },
          { text: 'Ποσότητα', value: 'Qty', align: 'end' },
          { text: 'Μονάδα', value: 'RepairItem.Unit', align: 'start', width: '10%' },
           { text: 'Κωδικός Προμ.', value: 'Order.ManufacturerSku' },
          { text: 'Τιμή Πώλησης', value: 'RepairItem.Price', align: 'end' },
          { text: 'Κέρδος (Συν.)', value: 'RepairItem.Profit', align: 'end' },
          { text: 'Actions', value: 'actions', width: '10%' },
        //  { text: '', value: 'data-table-expand' },
        ],
    }
  },
  async created() {
      try {
        const response = await this.$api.get('/inventory/parts/checkouts/'+this.$route.params.id);
        // console.log(response);
        // this.part = response.data;
        this.checkouts = response.data;
        this.loading = false;
      } catch (error) {
        console.error(error);
      }
    },
watch: {

},
  methods: {
  uniqYears(items) {
    //Store the unique
    let uniques = [];

    //Track the items added to the uniques
    let itemsFound = {};
    let year = 0;
    for (let val of items) {
      year = val['Timestamp'].slice(0,4);
      //console.log(year) //.getFullYear();
      //If item is already added then move to the next item
      if (itemsFound[val[year]]) {
        continue;
      }

      //Else push it to the unique list
      uniques.push(year);

      //Mark it as added
      itemsFound[year] = true;
    }

    //Return the uniques
    return uniques;
  },
  uniq(items, key) {
    //Store the unique
    let uniques = [];

    //Track the items added to the uniques
    let itemsFound = {};
    for (let val of items) {
      //If item is already added then move to the next item
      if (itemsFound[val[key]]) {
        continue;
      }

      //Else push it to the unique list
      uniques.push(val[key]);

      //Mark it as added
      itemsFound[val[key]] = true;
    }

    //Return the uniques
    return uniques;
  },

  tocurr(value) {
      return new Intl.NumberFormat("el-GR", {
        style: "currency",
        currency: "EUR",
      }).format(value);
    },
  showOrder(item) {
    let path = "Order"
    let params = {"id": item.OrderId}
    this.$router.push({"name": path, "params": params});
  },
  showRepair(item) {
     let path = "edit-repair"
    let params = {"repairId": item.RepairItem.RepairId}
    this.$router.push({"name": path, "params": params});
  },
  manufacturerQtyByYear(manufacturer) {
    if (this.invoicingPeriod) return this.orders.filter(order => order.Timestamp.slice(0,4) == this.invoicingPeriod).filter(order => order.Manufacturer == manufacturer).reduce((acc, order) => acc + order.Qty, 0)
    return this.checkouts.filter(checkout => checkout.order.Manufacturer == manufacturer).reduce((acc, checkout) => acc + checkout.Qty, 0)
  },

   async printLabels(item) {
    const options = {
      method: 'GET',
      params: {qty: this.labelQty, start_from: this.usedLabelQty},
      url: '/inventory/printlabel/'+item.Id,
      responseType: "blob",
    };


      this.$api(options).then((response) => {
      let url = window['URL'].createObjectURL(response.data)
      var a = document.createElement('a')
      a.href = url
      a.download = "labels.pdf";
      a.click()
      a.remove()
      setTimeout(() => window.URL.revokeObjectURL(url), 100)
    })
    .then(() => {
      // alert('File saved succesfully');
    })
    .catch((error) => {
      console.log(error);
    });

    },

  }
}
</script>
